import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49270a62"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=49270a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleSubHeader: require('/app/app/components/article/SubHeader/index.vue').default,ScrollProgress: require('/app/library/components/ScrollProgress/index.vue').default})
